import React, {FC} from "react";
import {SimpleTitle} from "../styles";
import { useTranslation } from "react-i18next";

export const NotificationCompetitionApplyResult: FC<{item: any}> = ({item}) => {
    const {
        actions,
    } = item;
    const { t, i18n } = useTranslation()

    const applyInfo = actions[0]?.fieldValues;

    const projectLink = applyInfo["projectLink"] || applyInfo["ProjectLink"]
    const projectName_ru = applyInfo["projectName_ru"] || applyInfo["ProjectName_ru"]
    const projectName_en = applyInfo["projectName_en"] || applyInfo["ProjectName_en"]
    const CompetitionLink = applyInfo["competitionLink"] || applyInfo["CompetitionLink"]
    const competitionName_ru = applyInfo["competitionName_ru"] || applyInfo["CompetitionName_ru"] || applyInfo[" competitionName_ru"] || applyInfo[" CompetitionName_ru"]
    const competitionName_en = applyInfo["сompetitionName_en"] || applyInfo["CompetitionName_en"] || applyInfo[" сompetitionName_en"] || applyInfo[" CompetitionName_en"]
    const competitionName = ((i18n.language === 'ru' && competitionName_ru) || !competitionName_en) ? competitionName_ru : competitionName_en
    const projectName = ((i18n.language === 'ru' && projectName_ru) || !projectName_en) ? projectName_ru : projectName_en

    if (!applyInfo) return null;

    // Заявка одобрена:
    // Ваш проект %проект был одобрен к участию в конкурсе %конкурс. Подробности на почте
    // Your project %project for the competition %competiton has been approved. We will provide additional information via e-mail

    // Заявка отклонена
    // Ваш проект %проект был отклонен от участия в конкурсе %конкурс. Подробности на почте.
    // Your project %project for the competition %competiton has been rejected. We will provide additional information via e-mail

    // console.log('competitionName', competitionName_ru, competitionName_en)

    if (!!actions[0]?.isApplied) {
        return <SimpleTitle>
            {t('notifications.competition_apply1')}
            <a href={projectLink}>{projectName}</a>
            {t('notifications.competition_apply2')}
            <a href={CompetitionLink}>{competitionName}{i18n.language === 'ru' ? '.' : ''}</a>
            {t('notifications.competition_apply3')}
        </SimpleTitle>
    }

    return <SimpleTitle>
        {t('notifications.competition_reject1')}
        <a href={projectLink}>{projectName}</a>
        {t('notifications.competition_reject2')}
        <a href={CompetitionLink}>{competitionName}{i18n.language === 'ru' ? '.' : ''}</a>
        {t('notifications.competition_reject3')}
    </SimpleTitle>
}import React, {FC} from "react";
import {SimpleTitle} from "../styles";
import { useTranslation } from "react-i18next";

export const NotificationCompetitionApplyResult: FC<{item: any}> = ({item}) => {
    const {
        actions,
    } = item;
    const { t, i18n } = useTranslation()

    const applyInfo = actions[0]?.fieldValues;

    const projectLink = applyInfo["projectLink"] || applyInfo["ProjectLink"]
    const projectName_ru = applyInfo["projectName_ru"] || applyInfo["ProjectName_ru"]
    const projectName_en = applyInfo["projectName_en"] || applyInfo["ProjectName_en"]
    const CompetitionLink = applyInfo["competitionLink"] || applyInfo["CompetitionLink"]
    const competitionName_ru = applyInfo["competitionName_ru"] || applyInfo["CompetitionName_ru"] || applyInfo[" competitionName_ru"] || applyInfo[" CompetitionName_ru"]
    const competitionName_en = applyInfo["сompetitionName_en"] || applyInfo["CompetitionName_en"] || applyInfo[" сompetitionName_en"] || applyInfo[" CompetitionName_en"]
    const competitionName = ((i18n.language === 'ru' && competitionName_ru) || !competitionName_en) ? competitionName_ru : competitionName_en
    const projectName = ((i18n.language === 'ru' && projectName_ru) || !projectName_en) ? projectName_ru : projectName_en

    if (!applyInfo) return null;

    // Заявка одобрена:
    // Ваш проект %проект был одобрен к участию в конкурсе %конкурс. Подробности на почте
    // Your project %project for the competition %competiton has been approved. We will provide additional information via e-mail

    // Заявка отклонена
    // Ваш проект %проект был отклонен от участия в конкурсе %конкурс. Подробности на почте.
    // Your project %project for the competition %competiton has been rejected. We will provide additional information via e-mail

    // console.log('competitionName', competitionName_ru, competitionName_en)

    if (!!actions[0]?.isApplied) {
        return <SimpleTitle>
            {t('notifications.competition_apply1')}
            <a href={projectLink}>{projectName}</a>
            {t('notifications.competition_apply2')}
            <a href={CompetitionLink}>{competitionName}{i18n.language === 'ru' ? '.' : ''}</a>
            {t('notifications.competition_apply3')}
        </SimpleTitle>
    }

    return <SimpleTitle>
        {t('notifications.competition_reject1')}
        <a href={projectLink}>{projectName}</a>
        {t('notifications.competition_reject2')}
        <a href={CompetitionLink}>{competitionName}{i18n.language === 'ru' ? '.' : ''}</a>
        {t('notifications.competition_reject3')}
    </SimpleTitle>
}